module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAAAXNSR0IArs4c6QAAAQZJREFUSEvtldFtwkAMhv3HA5QR6AaJlHsGNmlH6ATNBu1GhWdHOjaAEWCAiytLEFFEFV8LvJB7jX9/8ndWDiLSAHinGx4Ab2jbVm/I6Fv3IKN2Xbe+JrQoilJVP6xnD1LVRQhheU2QiMwBfI2gbKujumxlx8CoblTXG3icZVgD2P355i8EVXUCoPzx9/YCALwS0eT4zrhzOS+sqq5CCHNrLiJLALMckOl68gaI6MUmIqLPjMweMcYypdSYz6Hg+QQ2oSOzY+YGQ4Wn388113XtzrsLDXgXUIxxmlLanE7IzM9VVW09VgYnOgDiYQEu9bQ7qIaAHpAti4F+O3tmLv8N8mjx1HwDlSEGTaJ+NgcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/pc.png
// module id = SAGy
// module chunks = 1